import { createPortalUiResources } from '../../i18n/portalUiI18n';

const en = {
  title: 'Switch Application',
  current: 'Current',
  triggerLabel: 'Switch Application',
  applications: {
    portal: {
      title: 'Portal',
      description: 'Reporting, analytics, documents and workflows',
    },
    portalConfigurator: {
      title: 'Portal Configurator',
      description: 'Configure pages, branding and layout',
    },
    userManagement: {
      title: 'User Management',
      description: 'Manage users, roles and permissions',
    },
    trace: {
      title: 'TRACE',
      description: 'Document extraction, verification and signatory workflows',
    },
  },
};

const de = {
  title: 'Anwendung wechseln',
  current: 'Aktuell',
  triggerLabel: 'Anwendung wechseln',
  applications: {
    portal: {
      title: 'Portal',
      description: 'Reporting, Analysen, Dokumente und Workflows',
    },
    portalConfigurator: {
      title: 'Portal-Konfigurator',
      description: 'Seiten, Branding und Layout konfigurieren',
    },
    userManagement: {
      title: 'Benutzerverwaltung',
      description: 'Benutzer, Rollen und Berechtigungen verwalten',
    },
    trace: {
      title: 'TRACE',
      description:
        'Dokumentenextraktion, Verifizierung und Unterschriften-Workflows',
    },
  },
};

const es = {
  title: 'Cambiar de aplicación',
  current: 'Actual',
  triggerLabel: 'Cambiar de aplicación',
  applications: {
    portal: {
      title: 'Portal',
      description: 'Informes, análisis, documentos y flujos de trabajo',
    },
    portalConfigurator: {
      title: 'Configurador del portal',
      description: 'Configurar páginas, branding y diseño',
    },
    userManagement: {
      title: 'Gestión de usuarios',
      description: 'Gestionar usuarios, roles y permisos',
    },
    trace: {
      title: 'TRACE',
      description:
        'Extracción de documentos, verificación y flujos de firmantes',
    },
  },
};

export const applicationSwitcherResources = createPortalUiResources({
  en: { applicationSwitcher: en },
  de: { applicationSwitcher: de },
  es: { applicationSwitcher: es },
});
